<div class="modal-header d-flex justify-content-between mb-3">

  @if(adUserIdEdit() != '0') {
      <h3 class="modal-title">Användarinställningar</h3>
      @if(!showCloseButton()) {
          <h4 class="text-danger">Inställningarna behöver verifieras innan du kan gå vidare</h4>
      }
  } @else if(adUserIdEdit() == '0') {
      @if(contactToConvert() == '') {
          <h3 class="modal-title">Ny användare</h3>
      } @else {
          <h3 class="modal-title">Konvertera kontakt till användare</h3>
      }
  }

  <button type="button" title="Stäng" class="btn-close" (click)="cancelDialog()" aria-label="Close"></button>
</div>

<div class="container-fluid">
  @if(!authToEdit()) {
    <div class="row">
      <div class="col-12">
        <div class="alert alert-danger" role="alert">
          <div class="alert-heading">
            <h4>Rättigheter saknas för denna åtgärd</h4>
          </div>
        </div>
      </div>
    </div>
  } @else {

    @if(adUserIdEdit() === '0' && contactToConvert() !== '') {
          <div class="row mb-3">
              <div class="col-6">
                  <div class="form-group">
                      <p-floatlabel variant="on" class="w-100">
                        <p-select inputId="primary-contact" size="small" [ngModel]="contactToConvert()" (ngModelChange)="onContactToConvertChange($event)" [options]="allContactsList" optionLabel="name" optionValue="contactPersonId" [fluid]="true" />
                        <label for="primary-contact">Primär kontakt</label>
                      </p-floatlabel>
                  </div>
              </div>

              <div class="col-6">
                  <div class="form-group">
                      <p-floatlabel variant="on" class="w-100">
                        <p-select inputId="secondary-contact" size="small" [(ngModel)]="secondaryContactToConvert" (ngModelChange)="onSecondaryContactToConvertChange()" [options]="secondaryContactsList" optionLabel="name" optionValue="contactPersonId" [fluid]="true" />
                        <label for="secondary-contact">Sekundär kontakt</label>
                      </p-floatlabel>
                  </div>
              </div>
          </div>
        } @else {
          <p-tabs [value]="currentSelectTab()" (valueChange)="selectTab($event)">
            <p-tablist>
              <p-tab value="contact">Kontaktuppgifter</p-tab>
              <p-tab value="password">Lösenord</p-tab>
            </p-tablist>
            <p-tabpanels>
            <!-- GENERELLA KONTAKTUPPGIFTER -->
            <p-tabpanel value="contact">
              <div class="card rounded">
                <div class="card-body">
                  <div class="row mt-3">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-12 col-sm-4">
                          <div class="form-group">
                            <p-floatlabel variant="on" class="w-100">
                              <p-iconfield iconPosition="right" class="w-100">
                                <p-inputicon>
                                  @if(userToEdit.name.length > 0) {
                                    <i class="fa-duotone fa-circle-check text-success " title="Ok"></i>
                                  } @else if(userToEdit.name.length == 0) {
                                    <i class="fa-duotone fa-circle-exclamation text-danger " title="Saknas"></i>
                                  }
                                </p-inputicon>
                                <input pInputText id="user-name" pSize="small" class="w-100" type="text" maxlength="40" [(ngModel)]="userToEdit.name" (input)="change()" />
                              </p-iconfield>

                              <label for="user-name">Namn</label>
                            </p-floatlabel>
                            @if(userToEdit.name.length == 0) {
                              <span class="text-danger"> Namn är obligatoriskt</span>
                            }
                            @if(useSecondaryContact()) {
                              <p-floatlabel variant="on" class="d-inline-block mt-2" style="width:300px">
                                <input pInputText id="secondary-contact-name" pSize="small" class="w-100" type="text" [(ngModel)]="secondaryContact.name" [disabled]="true" />
                                <label for="secondary-contact-name">Sekundär kontakt</label>
                              </p-floatlabel>
                            }
                          </div>
                        </div>
                        <div class="col-12 col-sm-4">
                          <div class="form-group">
                            <p-floatlabel variant="on" class="w-100">
                              <p-iconfield iconPosition="right" class="w-100">
                                <p-inputicon>
                                    @if(userToEdit.emailAddressPersonal.length > 0 && !userEmailDirty() && userEmailValid()) {
                                      <i class="fa-duotone fa-circle-check text-success " title="Ok"></i>
                                    }
                                    @if(userToEdit.emailAddressPersonal.length == 0) {
                                      <i class="fa-duotone fa-circle-exclamation text-danger " title="Saknas"></i>
                                    }
                                  </p-inputicon>
                                  <input pInputText id="user-personal-email" pSize="small" class="w-100" type="email" name="emailPersonal" [(ngModel)]="userToEdit.emailAddressPersonal" (input)="change('emailPersonal')" />
                                </p-iconfield>
                              <label for="user-personal-email">E-post (personlig)</label>
                            </p-floatlabel>
                            @if(userToEdit.emailAddressPersonal.length == 0) {
                              <small class="text-danger fw-light"> E-postadress är obligatoriskt.</small>
                            }

                            @if(userEmailDirty() && userToEdit.emailAddressPersonal != '') {
                              <button class="btn btn-danger" (click)="verifyUserEmail()">Verifiera att e-postadressen är giltig.</button>
                            }

                            @if(!userEmailDirty() && !userEmailValid()) {
                              <small class="text-danger fw-light">
                                <i class="fa-duotone fa-circle-exclamation fa-1x text-danger" title="Ogiltig e-postadress"></i>
                                E-postadressen är ogiltig eller upptagen.
                                <i class="fa-duotone fa-circle-exclamation fa-1x text-danger" title="Ogiltig e-postadress"></i>
                                </small>
                            }

                            @if(userToEdit.emailAddressPersonal.length == 0) {
                              <small class="text-danger fw-light"> E-postadressen måste vara personlig och används för lösenordsåterställning och annan kommunikation med användaren. </small>
                            }
                          </div>
                        </div>
                        <div class="col-12 col-sm-4">
                          <div class="form-group">
                            @if(emailToUsername()) {
                              <p-floatlabel variant="on" class="w-100">
                                <input pInputText id="user-name-from-email" pSize="small" class="w-100" [(ngModel)]="userToEdit.emailAddressPersonal" [disabled]="true" />
                                <label for="user-name-from-email">Användarnamn</label>
                              </p-floatlabel>
                              <i class="fa-duotone fa-edit fa-1x clickable" title="Editera användarnamn" (click)="enableEditUsername()"></i>
                              @if(!useSecondaryContact()) {
                                <span class="clickable" (click)="enableEditUsername()">Editera användarnamn</span>
                              }
                            } @else {

                              <div style="white-space:nowrap">
                                <p-floatlabel variant="on" class="w-100">
                                  <input pInputText id="user-name-edit" pSize="small" class="w-100" [(ngModel)]="userToEdit.userName" (input)="change(); userToEditNameChange();" [disabled]="!editUsername()" />
                                  <label for="user-name-edit">Användarnamn</label>
                                </p-floatlabel>
                                @if(userToEdit.userName.length >= usernameMinLength() && userNameDirty()) {
                                  <button class="btn btn-danger" (click)="verifyUsername()">Verifiera att användarnamnet är giltigt</button>
                                } @else if(userToEdit.userName.length >= usernameMinLength() && editUsername() && !userNameDirty()) {
                                    @if(usernameValid()) {
                                      <i class="fa-duotone fa-circle-check fa-1x text-success" title="Användarnamn ok"></i>
                                    } @else {
                                      <i class="fa-duotone fa-circle-exclamation fa-1x text-danger" title="Användarnamn ogiltigt"></i>
                                      <small class="text-danger">Användarnamnet är ogiltigt eller upptaget</small>
                                    }
                                } @else if(userToEdit.userName.length < usernameMinLength()) {
                                  <i class="fa-duotone fa-circle-exclamation fa-1x text-danger" title="Användarnamn ogiltigt"></i>
                                  <small class="text-danger fw-light">Användarnamnet måste vara minst {{usernameMinLength()}} tecken långt</small>
                                }

                                @if(!editUsername()) {
                                  <small class="fw-light fw-light"><i class="fa-duotone fa-edit fa-1x clickable" title="Editera användarnamn" (click)="editUsername.set(!editUsername())"></i> Editera användarnamn</small>
                                }
                              </div>
                            }
                          </div>
                        </div>

                        <div class="col-12">
                          <hr>
                        </div>

                        @if(!isMF()) {

                          <div class="col-12 col-lg-4">
                            <div class="form-group">
                              @if(emailToQuote()) {
                                <div class="input-group mb-3">
                                  <p-floatlabel variant="on" class="flex-grow-1">
                                    <input pInputText id="quote-email-from-personal" pSize="small" type="email" class="w-100" [(ngModel)]="userToEdit.emailAddressPersonal" [disabled]="true">
                                    <label for="quote-email-from-personal">E-postadress för utskrift på offert</label>
                                  </p-floatlabel>
                                  <div class="d-flex" title="Editera E-post">
                                    <span class="input-group-text text-warning"><i class="fa-duotone fa-edit clickable" title="Editera E-postadress" (click)="emailToQuote.set(false)"></i></span>
                                  </div>
                                </div>
                              } @else {
                                <p-floatlabel variant="on" class="w-100">
                                  <p-iconfield iconPosition="right" class="w-100">
                                    <p-inputicon>
                                        @if(userToEdit.emailAddressQuote.length > 0) {
                                          <i class="fa-duotone fa-circle-check text-success " title="Ok"></i>
                                        } @else if(userToEdit.emailAddressQuote.length == 0) {
                                          <i class="fa-duotone fa-circle-exclamation text-danger " title="Saknas"></i>
                                        }
                                    </p-inputicon>
                                    <input pInputText id="quote-email" pSize="small" class="w-100" type="email" name="emailQuote" [(ngModel)]="userToEdit.emailAddressQuote" (input)="change('emailQuote')" />
                                  </p-iconfield>
                                  <label for="quote-email">E-postadress för utskrift på offert</label>
                                </p-floatlabel>

                                  @if(useSecondaryContact()) {
                                    <br />
                                  }
                                  @if(emailQuoteError()) {
                                    <small class="text-danger fw-light">{{emailError}}</small>
                                  }
                              }

                              @if(useSecondaryContact()) {
                                <p-floatlabel variant="on" class="w-100">
                                  <input pInputText id="secondary-quote-email" pSize="small" class="w-100" [(ngModel)]="secondaryContact.emailAddressQuote" [disabled]="true" />
                                  <label for="secondary-quote-email">Sekundär e-post för offert</label>
                                </p-floatlabel>
                              }
                            </div>
                          </div>
                          <div class="col-12 col-lg-4">
                            <div class="form-group">
                              @if(emailToOrder()) {
                                <p-floatlabel variant="on" class="w-100">
                                  <input pInputText id="order-email-from-personal" pSize="small" class="w-100" [(ngModel)]="userToEdit.emailAddressPersonal" [disabled]="true" />
                                  <label for="order-email-from-personal">E-postadress för ordererkännande</label>
                                </p-floatlabel>
                                <i class="fa-duotone fa-edit fa-1x clickable" (click)="emailToOrder.set(false)" title="Editera E-postadress"></i>
                                @if(!useSecondaryContact()) {
                                  <small class="clickable fw-light" (click)="emailToOrder.set(false)">Editera E-post</small>
                                }
                              }

                              <button type="button" class="btn btn-sm btn-outline-success mb-4 w-100" title="Lägg till e-postadress för ordererkännande" (click)="addEmailOrder()">
                                <i class="fa-duotone fa-fw fa-plus"></i> Lägg till e-post för ordererkännande
                              </button>

                              @if(!emailToOrder() && userToEdit.emailAddressesOrder.length > 0){
                                <div class="d-flex flex-column">
                                  @for(item of userToEdit.emailAddressesOrder; track $index; let i = $index){

                                    <p-floatlabel variant="on" class="flex-grow-1">
                                      <p-inputgroup class="user-email-inputgroup mb-3">
                                        <input pInputText [id]="'order-email-' + i" pSize="small" type="email" class="w-100" name="emailOrder_{{i}}" [(ngModel)]="userToEdit.emailAddressesOrder[i]" (input)="change('emailOrder', i)">
                                        <p-inputgroup-addon class="p-0">
                                          <button pButton size="small" title="Ta bort" severity="danger" [text]="true" ariaLabel="Ta bort e-postadress" (onClick)="removeEmailOrder(item)"><i class="fa-duotone fa-trash"></i></button>
                                        </p-inputgroup-addon>
                                      </p-inputgroup>
                                      <label [for]="'order-email-' + i">E-postadress för ordererkännande</label>
                                    </p-floatlabel>

                                    @if(useSecondaryContact()) {
                                      <br />
                                    }
                                    @if(emailOrderError()) {
                                      <small class="text-danger fw-light">{{emailError}}</small>
                                    }
                                  }
                                </div>
                              }

                              @if(useSecondaryContact()) {
                                <div>
                                  @for(item of secondaryContact.emailAddressOrder; track $index) {
                                    <p-floatlabel variant="on" class="w-100">
                                      <input pInputText [id]="'secondary-order-email-' + $index" pSize="small" class="w-100" [(ngModel)]="secondaryContact.emailAddressOrder[$index]" [disabled]="true" />
                                      <label [for]="'secondary-order-email-' + $index">Sekundär e-post för order</label>
                                    </p-floatlabel>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                          <div class="col-12 col-lg-4">
                            <div class="form-group">
                              @if(emailToDelivery()) {
                                <p-floatlabel variant="on" class="w-100">
                                  <input pInputText id="delivery-email-from-personal" pSize="small" class="w-100" [(ngModel)]="userToEdit.emailAddressPersonal" [disabled]="true" />
                                  <label for="delivery-email-from-personal">E-postadress för leveransbekräftelse</label>
                                </p-floatlabel>
                                <i class="fa-duotone fa-edit fa-1x clickable" title="Editera E-postadress" (click)="emailToDelivery.set(false)"></i>
                                @if(!useSecondaryContact()) {
                                  <small class="clickable fw-light" (click)="emailToDelivery.set(false)">Editera E-post</small>
                                }
                              }

                              <button type="button" class="btn btn-sm btn-outline-success mb-4 w-100" (click)="addEmailDelivery()">
                                <i class="fa-duotone fa-plus" title=">Lägg till e-postadress för leveransbekräftelse"></i>&nbsp;Lägg till e-post för leveransbekräftelse
                              </button>

                              @if(!emailToDelivery() && userToEdit.emailAddressesDeliver.length > 0) {
                                <div class="d-flex flex-column">
                                  @for(item of userToEdit.emailAddressesDeliver; track $index; let i = $index) {
                                    <p-floatlabel variant="on" class="flex-grow-1">
                                      <p-inputgroup class="user-email-inputgroup mb-3">
                                        <input pInputText [id]="'delivery-email-' + i" pSize="small" type="email" class="w-100" name="emailDeliver_{{i}}" [(ngModel)]="userToEdit.emailAddressesDeliver[i]" (input)="change('emailDelivery', i)">
                                        <p-inputgroup-addon class="p-0">
                                          <button pButton size="small" severity="danger" title="Ta bort" [text]="true" ariaLabel="Ta bort e-postadress" (onClick)="removeEmailDelivery(item)"><i class="fa-duotone fa-trash"></i></button>
                                        </p-inputgroup-addon>
                                      </p-inputgroup>
                                      <label [for]="'delivery-email-' + i">E-postadress för leveransbekräftelse</label>
                                    </p-floatlabel>



                                    @if(useSecondaryContact()) {
                                      <br />
                                    }
                                    @if(emailDeliveryError()) {
                                      <small class="text-danger fw-light">{{emailError}}</small>
                                    }
                                  }
                                </div>
                              }

                              @for(item of secondaryContact.emailAddressDeliver; track $index; let i = $index) {
                                <p-floatlabel variant="on" class="w-100">
                                  <input pInputText [id]="'secondary-delivery-email-' + i" pSize="small" class="w-100" type="email" name="emailDeliver_{{i}}" [(ngModel)]="secondaryContact.emailAddressDeliver[i]" [disabled]="true" />
                                  <label [for]="'secondary-delivery-email-' + i">Sekundär e-post för leverans</label>
                                </p-floatlabel>
                              }
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <p-floatlabel variant="on" class="w-100">
                                <input pInputText id="user-phone" pSize="small" class=" w-100" type="text" [(ngModel)]="userToEdit.phone" (input)="change()" />
                                <label for="user-phone">Telefon</label>
                              </p-floatlabel>
                              @if(useSecondaryContact()) {
                                  <p-floatlabel variant="on" class="w-100 mt-2">
                                    <input pInputText id="secondary-user-phone" pSize="small" class=" w-100" type="text" [(ngModel)]="secondaryContact.phone" [disabled]="true" />
                                    <label for="secondary-user-phone">Sekundär telefon</label>
                                  </p-floatlabel>
                              }
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <p-floatlabel variant="on" class="w-100">
                                <input pInputText id="user-cellular-phone" pSize="small" class=" w-100" type="text" [(ngModel)]="userToEdit.cellularPhone" (input)="change()" />
                                <label for="user-cellular-phone">Mobil</label>
                              </p-floatlabel>
                              @if(useSecondaryContact()) {
                                <p-floatlabel variant="on" class="w-100 mt-2">
                                  <input pInputText id="secondary-user-cellular-phone" pSize="small" class=" w-100" type="text" [(ngModel)]="secondaryContact.cellularPhone" [disabled]="true" />
                                  <label for="secondary-user-cellular-phone">Sekundär mobil</label>
                                </p-floatlabel>
                              }
                            </div>
                          </div>
                        }

                        <div class="col-12">
                          <div class="form-group py-3">
                            @if(isAllowedToEditUsers()) {
                              <check-box [title]="'Aktiv'" [value]="userToEdit.enabled" (onSwitch)="userToEdit.enabled = $event; change()" [enabled]="isAllowedToEditUsers()"></check-box>
                            } @else if(allowedToEditLoading()) {
                              <span><i class="fa-duotone fa-spinner" title="Kontrollerar rättigheter"></i> Kontrollerar rättigheter att aktivera/avaktivera användare...</span>
                            }

                            @if(!isAllowedToEditUsers() && !allowedToEditLoading()) {
                              <span class="text-danger">
                                <i class="fa-duotone fa-circle-exclamation fa-1x" title="Otillräckliga rättigheter"></i> Rättighet att aktivera/avaktivera användare saknas. Vänligen kontakta support.
                              </span>
                            }
                          </div>
                        </div>

                        @if(isAdmin() && isEnabled_SalesConfirmEdi()) {
                          <div class="col-12">
                            <div class="form-group">
                              <p-floatlabel variant="on" class="w-100">
                                <input pInputText id="external-user-id" pSize="small" class=" w-100" type="text" autocomplete="new-password" [(ngModel)]="userToEdit.externalUserId" (input)="change()" />
                                @if(isEnabled_SalesConfirmEdi_Trygg()) {
                                  <label for="external-user-id">Trygg-ID</label>
                                }
                              </p-floatlabel>
                            </div>
                          </div>
                        }

                        <div class="col-12">
                          <hr />
                        </div>

                        @if(isReseller() && userToEdit) {
                          <div class="col-12">
                            <div class="d-flex flex-column gap-2">
                              <label class="text-muted">Förvald invändig profil:</label>
                              <div>
                                <p-radiobutton name="preSelectedBrand" value="" size="small" inputId="radio_preSelectedBrand" [(ngModel)]="userToEdit.preSelectedBrand" (ngModelChange)="change()" />
                                <label for="radio_preSelectedBrand" class="ms-2">Inget förvalt</label>
                              </div>
                              <div>
                                <p-radiobutton name="preSelectedBrand" value="SP" size="small" inputId="radio_preSelectedBrand_SP" [(ngModel)]="userToEdit.preSelectedBrand" (ngModelChange)="change()" />
                                <label for="radio_preSelectedBrand_SP" class="ms-2">Rund</label>
                              </div>
                              <div>
                                <p-radiobutton name="preSelectedBrand" value="TR" size="small" inputId="radio_preSelectedBrand_TR" [(ngModel)]="userToEdit.preSelectedBrand" (ngModelChange)="change()" />
                                <label for="radio_preSelectedBrand_TR" class="ms-2">Rak</label>
                              </div>
                            </div>
                          </div>
                        }

                        <div class="col-12">
                            <hr />
                        </div>

                        <div class="col-12">
                          @if((dirty() && (!userFields())) || !userEmailValid() || (!usernameValid() && editUsername())){
                            <p-message severity="error" size="small" variant="outlined">
                              @if(!userFields()) {
                                <span class="text-danger">Ett eller flera fält ovan är felaktiga. <br /> Korrigera felen innan du sparar ändringarna.</span>
                              }
                              <br />
                              @if(!userEmailValid()) {
                                <span class="text-danger">Den personliga e-postadressen är ogiltig eller upptagen.</span>
                              }
                              <br />
                              @if(!usernameValid() && editUsername()) {
                                <span class="text-danger">Användarnamnet är ogiltig eller upptaget.</span>
                              }
                            </p-message>
                          }
                        </div>

                        @if(adUserIdEdit() != '0') {
                          <div class="d-flex gap-2 mt-3">
                            <button class="btn btn-primary" (click)="reloadUserToEdit()" [disabled]="!dirty()">Ångra ändringar</button>
                            <button class="btn btn-outline-primary" (click)="verifyAndSave('editUser')" [disabled]="!dirty() || !userFields()">Spara Användaruppgifter</button>
                          </div>
                        }

                        <div class="col-12">
                          @if(errorMessage()) {
                            <div class="alert alert-danger">
                              {{ errorMessage() }}
                            </div>
                          }

                          @if(infoMessage()) {
                              <div class="alert alert-light">
                                  {{ infoMessage() }}
                              </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </p-tabpanel>
            <!-- LÖSENORD -->
            <p-tabpanel value="password">
              <div class="card rounded">
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-12">
                      <p-fieldset [toggleable]="true" [collapsed]="true" legend="Lösenordskriterier">
                          <p-message severity="secondary">
                            <span>Lösenordet måste vara minst {{minPasswordLength()}} tecken långt</span><br />
                            <span>Lösenordet måste innehålla tecken från minst {{minPasswordComplexity()}} av grupperna nedan</span><br />
                            <ul>
                              <li>Små bokstäver</li>
                              <li>Stora bokstäver</li>
                              <li>Siffror</li>
                              <li>Specialtecken (&#64;!? etc)</li>
                            </ul>
                            <span>Lösenordet får inte innehålla</span><br />
                            <ul>
                              <li>Ditt förnamn eller efternamn</li>
                              <li>Ditt användarnamn</li>
                              <li>Din e-postadress</li>
                            </ul>
                          </p-message>
                        </p-fieldset>
                    </div>

                    <!-- Hide 'Nuvarande lösenord' if admin is editing another user -->
                    @if(adUserIdEdit() != '0' && adUserIdEdit() == adUserId()) {
                        <div class="col-12">
                            <div class="form-group">
                                <p-floatlabel variant="on" class="w-100">
                                  <input pInputText id="current-password" autocomplete="off" pSize="small" type="password" class="w-100" autocomplete="new-password" [ngModel]="oldPassword()" #currentPassword (ngModelChange)="oldPassword.set(currentPassword.value)" />
                                  <label for="current-password">Nuvarande lösenord</label>
                                </p-floatlabel>
                            </div>
                        </div>
                    }

                    <div class="col-6">
                      <div class="form-group">
                        <p-floatlabel variant="on" class="w-100">
                          <input pInputText id="new-password" pSize="small" type="password" class="w-100" autocomplete="new-password" [ngModel]="password1()" #newPwd1 (input)="changePassword1(newPwd1.value)" />
                          <label for="new-password">Nytt lösenord</label>
                        </p-floatlabel>
                        @if(password1().length > 0 && isValidPassword1) {
                            <i class="fa-duotone fa-circle-check fa-1x text-success" title="Ok"></i>
                        }
                        <!-- Short password -->
                        @if(!isValidPassword1 && passwordErrorMessage && password1().length < minPasswordLength()) {
                          <div class="mt-2">
                            <p-message size="small" severity="error" variant="outlined">{{passwordErrorMessage}}</p-message>
                          </div>
                        }
                        <!-- Weak password -->
                        @if(!isValidPassword1 && password1().length >= minPasswordLength()) {
                          <div class="mt-2">
                            <p-message size="small" severity="error" variant="outlined">{{passwordErrorMessage}}</p-message>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <p-floatlabel variant="on" class="w-100">
                          <input pInputText id="repeat-password" pSize="small" type="password" class=" w-100" autocomplete="new-password" [ngModel]="password2()" #newPwd2 (ngModelChange)="password2.set(newPwd2.value)" />
                          <label for="repeat-password">Upprepa lösenord</label>
                        </p-floatlabel>

                        @if(isValidPassword1) {
                            @if(password2() !== '' && password1() == password2()) {
                                <i class="fa-duotone fa-circle-check fa-1x text-success" title="Ok"></i>
                            } @else if(password1() != password2()){
                                <i class="fa-duotone fa-circle-exclamation fa-1x text-danger" title="Lösenorden matchar inte"></i>
                            }
                        }
                      </div>
                      <div class="btn-group float-end my-2">
                        @if(adUserIdEdit() !== '0') {
                            @if(adUserIdEdit() !== adUserId()) {
                                <button class="btn btn-sm btn-primary" (click)="onSubmitForm('setPassword')" [disabled]="!dirtyPassword || !isValidPassword1 || password1() !== password2()">Sätt lösenord</button>
                            } @else {
                                <button class="btn btn-sm btn-primary" (click)="onSubmitForm('savePassword')" [disabled]="!dirtyPassword || !isValidPassword1 || password1() !== password2() || !oldPassword()">Spara lösenord</button>
                            }
                        } @else {
                            @if(!contactToConvert()) {
                              <button class="btn btn-sm btn-success" (click)="onSubmitForm('addUser')" [disabled]="!dirty() || !isValidPassword1 || password1() !== password2() || !newUserFields() || !userFields() || addUserLoading()">
                                Lägg till användare
                                @if(addUserLoading()) {
                                  <span><i class="fa-duotone fa-spinner fa-puls fa-1x ms-2"></i></span>
                                }
                              </button>
                            } @else {
                              <button class="btn btn-sm btn-success" (click)="onSubmitForm('convertContact')" [disabled]="!dirty() || !isValidPassword1 || password1() !== password2() || !newUserFields() || !userFields()">Konvertera till användare</button>
                            }
                        }
                      </div>
                    </div>
                    @if(infoMessagePassword() || errorMessagePassword()) {
                      <div class="col-12">
                          @if(errorMessagePassword()) {
                              <div id="errorMessagePassword" class="alert alert-danger">
                                  {{errorMessagePassword()}}
                              </div>
                          }
                          @if(infoMessagePassword() && errorMessagePassword() == '') {
                              <div id="infoMessagePassword" class="alert alert-light">
                                  {{infoMessagePassword()}}
                              </div>
                          }
                      </div>
                    }

                    <div class="col-12">
                      @if(errorMessage()) {
                        <div class="alert alert-danger">
                          {{ errorMessage() }}
                        </div>
                      }

                      @if(infoMessage()) {
                          <div class="alert alert-light">
                              {{ infoMessage() }}
                          </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
        }
  }
</div>
